import { ColorProps, PositionProps, Tooltip } from '@chakra-ui/react'
import { HTMLAttributes, ReactElement } from 'react'
import { MarginProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import { Info } from 'designSystem/assets/icons'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

import PDSBox from '../PDSBox/PDSBox'
import PDSText from '../PDSText/PDSText'

type ToolTipSize = 'sm' | 'md' | 'lg'

type BaseProps = HTMLAttributes<HTMLDivElement> &
  ColorProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  size?: ToolTipSize
  content?: string | ReactElement
  testId?: string
} & BaseProps

export default function PDSTooltip({
  content,
  size = 'sm',
}: Props): ReactElement {
  const tooltipSize = TOOLTIP_SIZE[size] ?? TOOLTIP_SIZE.sm

  const LabelComponent =
    typeof content === 'string' ? (
      <PDSBox>
        <PDSText color={COLOR.grey300}>{content}</PDSText>
      </PDSBox>
    ) : (
      content
    )

  return (
    <Tooltip
      border={`1px solid ${COLOR.content_border}`}
      backgroundColor={COLOR.black}
      borderRadius={SIZE.s8}
      color={COLOR.textPrimary}
      hasArrow={true}
      label={LabelComponent}
      placement="auto-start"
    >
      <Info color={COLOR.textTertiary} width={tooltipSize} />
    </Tooltip>
  )
}

const TOOLTIP_SIZE: { [key: string]: string } = {
  sm: SIZE.s16,
  md: SIZE.s20,
  lg: SIZE.s24,
}
